export default "__VITE_ASSET__399d967d__"